// src/components/Authorizations/Authorizations.js

import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Row,
  Col,
  Spin,
  Pagination,
  Modal,
  Button,
  message,
  Typography,
  Tag,
  Space,
  Card,
  Alert,
  Radio,
} from "antd";
import { FixedSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import api from "../../../axiosConfig";
import { mensajeErrorDescarga } from "../../../utils/descargas";
import Filters from "./Filters";
import AuthorizationCard from "./AuthorizationCard";
import CreateAuthorizationForm from "./CreateAuthorizationForm/CreateAuthorizationForm";
import EditAuthorizationForm from "./EditAuthorizationForm/EditAuthorizationForm";
import ViewAuthorizationDialog from "./ViewAuthorizationDialog";
import BulkUpload from "./BulkUploadAuthorizations";
import CreateNovedadForm from "./CreateNovedadForm";
import HistorialNovedadesDialog from "./HistorialNovedadesDialog";
import HistorialAutorizacionDialog from "./HistorialAutorizacionDialog";
import VersionesAutorizacionDialog from "./VersionesAutorizacionDialog";
import ObservacionesAutorizacionDialog from "./ObservacionesAutorizacionDialog";
import dayjs from "../../../utils/dayjs";
import "./Authorizations.css"; // Asegúrate de importar el CSS
import { DownloadOutlined } from "@ant-design/icons"; //cambio
import { DatePicker } from "antd"; //cambio
import { useUser } from "../../../UserContext";

const { RangePicker } = DatePicker; //cambio
const { Text } = Typography;

const Authorizations = () => {
  const [exportModalVisible, setExportModalVisible] = useState(false); //cambio
  const [exportDateRange, setExportDateRange] = useState(null); //cambio
  const [exportLoading, setExportLoading] = useState(false); //cambio
  const [exportError, setExportError] = useState(null);
  const [authorizations, setAuthorizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openCreateEditForm, setOpenCreateEditForm] = useState(false);
  const [currentAuthorization, setCurrentAuthorization] = useState(null);
  const [openViewForm, setOpenViewForm] = useState(false);
  const [selectedAuthorizationId, setSelectedAuthorizationId] = useState(null);
  const [openBulkUpload, setOpenBulkUpload] = useState(false);
  const [exportDateType, setExportDateType] = useState("creacion");

  // Filtros
  const [filter, setFilter] = useState("");
  const [filterStatus, setFilterStatus] = useState("Activa"); // Establecer "Activa" como estado inicial
  const [filterAdditionalStatus, setFilterAdditionalStatus] = useState("");
  const [filterAuthType, setFilterAuthType] = useState("");
  const [filterEPS, setFilterEPS] = useState("");
  const [filterNoPbs, setFilterNoPbs] = useState("");
  const [filterDateRange, setFilterDateRange] = useState("");
  const [filterCustomDateRange, setFilterCustomDateRange] = useState([]);

  // Paginación (server-side optimizada)
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalAuthorizations, setTotalAuthorizations] = useState(0);

  // Otros estados
  const [openCreateNovedadForm, setOpenCreateNovedadForm] = useState(false);
  const [openHistorialNovedades, setOpenHistorialNovedades] = useState(false);
  const [openHistorialAutorizacion, setOpenHistorialAutorizacion] =
    useState(false);
  const [openVersiones, setOpenVersiones] = useState(false);
  const [openObservacionesAutorizacion, setOpenObservacionesAutorizacion] = useState(false);
  const [selectedVersionData, setSelectedVersionData] = useState(null);
  const [viewingHistoricalVersion, setViewingHistoricalVersion] = useState(false);
  const [modalKey, setModalKey] = useState(0);
  const [epsOptions, setEpsOptions] = useState([]);

  const { user: currentUser } = useUser();

  const hasPermission = useCallback(
    (permission) => {
      const module = currentUser?.modulos?.find(
        (m) => m.key?.toLowerCase() === "autorizaciones"
      );
      if (!module || module.estado !== "disponible") return false;

      return currentUser?.modulosPermisos?.some(
        (mp) => mp.modulo?.toLowerCase() === "autorizaciones" && mp.permiso === permission
      );
    },
    [currentUser]
  );

  const resetExportModal = useCallback(() => {
    setExportDateRange(null);
    setExportDateType("creacion");
    setExportError(null);
  }, []);

  //funcion para la exportacion de autorizaciones
  const handleExport = async () => {
    if (!exportDateRange || !exportDateRange[0] || !exportDateRange[1]) {
      message.error("Por favor seleccione un rango de fechas");
      return;
    }

    const startDate = exportDateRange[0];
    const endDate = exportDateRange[1];
    const diffInDays = Math.abs(endDate.diff(startDate, "days"));

    if (diffInDays > 90) {
      message.error("El rango de fechas no puede ser mayor a 3 meses");
      return;
    }

    try {
    setExportLoading(true);
    setExportError(null);

    // Incluir todos los filtros actuales (sin paginación para exportar todo)
    const params = {
      fechaInicio: startDate.format("YYYY-MM-DD"),
      fechaFin: endDate.format("YYYY-MM-DD"),
      campoFecha: exportDateType,
      // Incluir filtros de la vista actual
      search: filter || undefined,
      status: filterStatus || undefined,
      additionalStatus: filterAdditionalStatus || undefined,
      authType: filterAuthType || undefined,
      eps: filterEPS || undefined,
      no_pbs: filterNoPbs || undefined,
      // No incluir paginación para exportar todos los resultados
      export: true,
    };

    // Si hay filtros de fecha personalizados activos, incluirlos también
    if (filterCustomDateRange.length === 2) {
      params.start_date = filterCustomDateRange[0].format("YYYY-MM-DD");
      params.end_date = filterCustomDateRange[1].format("YYYY-MM-DD");
    } else if (filterDateRange) {
      const { startDate: filterStart, endDate: filterEnd } = getDateRange(filterDateRange);
      if (filterStart && filterEnd) {
        params.start_date = filterStart.format("YYYY-MM-DD");
        params.end_date = filterEnd.format("YYYY-MM-DD");
      }
    }

    const response = await api.get("/autorizaciones/exportar", {
      params,
      responseType: "blob",
    });

      const tipoNombre =
        {
          creacion: "Creacion",
          inicio: "Inicio",
          fin: "Final",
          rango_completo: "RangoCompleto",
        }[exportDateType] || "Reporte";

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Autorizaciones_${tipoNombre}_${startDate.format(
          "YYYY-MM-DD"
        )}_${endDate.format("YYYY-MM-DD")}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Reporte exportado con éxito");
      setExportModalVisible(false);
      setExportDateRange(null);
      resetExportModal();
    } catch (error) {
      console.error("Error al exportar el reporte: ", error);
      const mensaje = await mensajeErrorDescarga(error, "Error al exportar el reporte");
      message.error(mensaje);
      setExportError(mensaje);
    } finally {
      setExportLoading(false);
    }
  };

  // Función para obtener el rango de fechas basado en la selección
  const getDateRange = useCallback((range) => {
    const today = dayjs();
    let startDate, endDate;

    const getMonday = (d) => {
      const day = d.day();
      const diff = day === 0 ? 6 : day - 1;
      return d.subtract(diff, "day").startOf("day");
    };

    if (range === "current_week") {
      startDate = getMonday(today);
      endDate = startDate.add(6, "day").endOf("day");
    } else if (range === "previous_week") {
      startDate = getMonday(today).subtract(7, "day");
      endDate = startDate.add(6, "day").endOf("day");
    } else if (range === "current_month") {
      startDate = today.startOf("month");
      endDate = today.endOf("month");
    } else if (range === "previous_month") {
      startDate = today.subtract(1, "month").startOf("month");
      endDate = startDate.endOf("month");
    }

    return { startDate, endDate };
  }, []);

  /**
   * Obtiene autorizaciones con paginación server-side optimizada.
   * Rango de fechas por defecto: últimas 2 semanas.
   */
  const fetchAuthorizations = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        page: page,
        per_page: rowsPerPage,
        search: filter || undefined,
        status: filterStatus || undefined,
        additionalStatus: filterAdditionalStatus || undefined,
        authType: filterAuthType || undefined,
        eps: filterEPS || undefined,
        no_pbs: filterNoPbs || undefined,
      };

      if (filterCustomDateRange.length === 2) {
        params.start_date = filterCustomDateRange[0].format("YYYY-MM-DD");
        params.end_date = filterCustomDateRange[1].format("YYYY-MM-DD");
      } else if (filterDateRange) {
        const { startDate, endDate } = getDateRange(filterDateRange);
        if (startDate && endDate) {
          params.start_date = startDate.format("YYYY-MM-DD");
          params.end_date = endDate.format("YYYY-MM-DD");
        }
      }

      const response = await api.get("/autorizaciones", {
        params,
      });
      
      // Actualizar datos de paginación
      setAuthorizations(response.data.data || []);
      setTotalAuthorizations(response.data.total || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error al obtener autorizaciones:", error);
      message.error(
        "Error al cargar las autorizaciones. Por favor, intenta nuevamente."
      );
      setLoading(false);
    }
  }, [
    page,
    rowsPerPage,
    filter,
    filterStatus,
    filterAdditionalStatus,
    filterAuthType,
    filterEPS,
    filterNoPbs,
    filterDateRange,
    filterCustomDateRange,
    getDateRange,
  ]);

  // Solo re-fetch cuando cambien los filtros, no cuando cambia paginación
  useEffect(() => {
    fetchAuthorizations();
  }, [fetchAuthorizations]);

  // Obtener opciones de EPS al montar el componente (filtrado por rol del usuario)
  useEffect(() => {
    const fetchEpsOptions = async () => {
      try {
        // Usar endpoint que filtra por rol del usuario
        const response = await api.get("/roles/clientes/usuario");
        const { clientes, tiene_restriccion } = response.data;

        if (tiene_restriccion && clientes && clientes.length > 0) {
          // Si tiene restricción, mostrar solo los clientes permitidos
          setEpsOptions(clientes.map(c => ({
            id: c.id,
            nombre_cliente: c.nombre
          })));
        } else {
          // Si no tiene restricción, cargar todos los clientes
          const allClientes = await api.get("/clientes/list");
          setEpsOptions(allClientes.data);
        }
      } catch (error) {
        console.error("Error al cargar las opciones de EPS:", error);
        // Fallback: cargar todos los clientes
        try {
          const fallback = await api.get("/clientes/list");
          setEpsOptions(fallback.data);
        } catch (e) {
          console.error("Error en fallback de EPS:", e);
        }
      }
    };
    fetchEpsOptions();
  }, []);

  // Manejo de Filtros (optimizado para server-side pagination)
  const handleFilterChange = useCallback(
    (newFilter) => {
      // Solo si es distinto al filtro anterior
      if (newFilter !== filter) {
        setFilter(newFilter);
        setPage(1); // Reset page when filter changes
      }
    },
    [filter]
  );

  const handleFilterAuthTypeChange = useCallback((value) => {
    setFilterAuthType(value || "");
    setPage(1);
  }, []);

  const handleFilterEPSChange = useCallback((value) => {
    setFilterEPS(value || "");
    setPage(1);
  }, []);

  const handleStatusChange = useCallback((value) => {
    setFilterStatus(value || "");
    setPage(1);
  }, []);

  const handleFilterAdditionalStatusChange = useCallback((value) => {
    setFilterAdditionalStatus(value || "");
    setPage(1);
  }, []);

  const handleFilterNoPbsChange = useCallback((value) => {
    setFilterNoPbs(value || "");
    setPage(1);
  }, []);

  const handleFilterDateRangeChange = useCallback((value) => {
    setFilterDateRange(value || "");
    setPage(1);
  }, []);

  const handleFilterCustomDateRangeChange = useCallback((dates) => {
    setFilterCustomDateRange(dates);
    setPage(1);
  }, []);

  // Manejadores de Paginación
  const handlePageChange = useCallback((current) => {
    setPage(current);
  }, []);

  const handlePageSizeChange = useCallback((current, size) => {
    setPage(current);
    setRowsPerPage(size);
  }, []);

  // Manejadores de Modal para Crear/Editar Autorización
  const handleOpenCreateForm = useCallback(() => {
    setModalKey((prevKey) => prevKey + 1);
    setCurrentAuthorization(null);
    setOpenCreateEditForm(true);
  }, []);

  const handleOpenEditForm = useCallback((authorization) => {
    setCurrentAuthorization(authorization);
    setOpenCreateEditForm(true);
  }, []);

  const handleCloseCreateEditForm = useCallback(() => {
    setOpenCreateEditForm(false);
    setCurrentAuthorization(null);
  }, []);

  // Manejadores de Modal para Ver Autorización
  const handleOpenViewForm = useCallback((authorizationId) => {
    setSelectedAuthorizationId(authorizationId);
    setOpenViewForm(true);
  }, []);

  const handleCloseViewForm = useCallback(() => {
    setOpenViewForm(false);
    setSelectedAuthorizationId(null);
  }, []);

  // Manejadores de Modal para Carga Masiva
  const handleOpenBulkUpload = useCallback(() => {
    setOpenBulkUpload(true);
  }, []);

  const handleCloseBulkUpload = useCallback(() => {
    setOpenBulkUpload(false);
  }, []);

  // Manejador de Selección de Autorización
  const handleSelectAuthorization = useCallback((authorizationId) => {
    setSelectedAuthorizationId((prevId) =>
      prevId === authorizationId ? null : authorizationId
    );
  }, []);

  // Manejadores de Novedades
  const handleOpenCreateNovedadForm = useCallback((authorization) => {
    setCurrentAuthorization(authorization);
    setOpenCreateNovedadForm(true);
  }, []);

  const handleCloseCreateNovedadForm = useCallback(() => {
    setOpenCreateNovedadForm(false);
    setCurrentAuthorization(null);
  }, []);

  const handleOpenHistorialNovedades = useCallback((authorizationId) => {
    setSelectedAuthorizationId(authorizationId);
    setOpenHistorialNovedades(true);
  }, []);

  const handleCloseHistorialNovedades = useCallback(() => {
    setOpenHistorialNovedades(false);
    setSelectedAuthorizationId(null);
  }, []);

  // Manejador de Eliminación de Autorización
  const handleDeleteAuthorization = useCallback((authorizationId) => {
    console.log("Eliminar autorización con ID:", authorizationId);
    // Implementar lógica de eliminación aquí
  }, []);

  // Manejadores de Historial de Autorización
  const handleOpenHistorialAutorizacion = useCallback((authorizationId) => {
    setSelectedAuthorizationId(authorizationId);
    setOpenHistorialAutorizacion(true);
  }, []);

  const handleCloseHistorialAutorizacion = useCallback(() => {
    setOpenHistorialAutorizacion(false);
    setSelectedAuthorizationId(null);
  }, []);

  // Manejadores de Versiones de Autorización
  const handleOpenVersiones = useCallback((authorizationId) => {
    setSelectedAuthorizationId(authorizationId);
    setOpenVersiones(true);
  }, []);

  const handleCloseVersiones = useCallback(() => {
    setOpenVersiones(false);
  }, []);

  // Manejadores de Observaciones de Autorizacion
  const handleOpenObservacionesAutorizacion = useCallback((authorizationId) => {
    setSelectedAuthorizationId(authorizationId);
    setOpenObservacionesAutorizacion(true);
  }, []);

  const handleCloseObservacionesAutorizacion = useCallback(() => {
    setOpenObservacionesAutorizacion(false);
    setSelectedAuthorizationId(null);
  }, []);

  const handleViewVersion = useCallback(async (numeroVersion) => {
    try {
      const response = await api.get(
        `/autorizaciones/${selectedAuthorizationId}/versiones/${numeroVersion}`
      );
      setSelectedVersionData(response.data);
      setViewingHistoricalVersion(true);
      setOpenVersiones(false);
      setOpenViewForm(true);
    } catch (error) {
      console.error("Error al obtener la versión:", error);
      message.error("Error al cargar la versión seleccionada");
    }
  }, [selectedAuthorizationId]);

  const handleCloseVersionView = useCallback(() => {
    setOpenViewForm(false);
    setSelectedVersionData(null);
    setViewingHistoricalVersion(false);
    setSelectedAuthorizationId(null);
  }, []);

  // Función para obtener el color del borde según el estado
  const getBorderColor = useCallback((estado) => {
    if (!estado) return "#d9d9d9";
    switch (estado.toLowerCase()) {
      case "activa":
        return "#2f54eb";
      case "suspendida":
        return "#fa541c";
      case "completada":
        return "#52c41a";
      default:
        return "#d9d9d9";
    }
  }, []);

  // Memoizar las autorizaciones con transformaciones necesarias
  const memoizedAuthorizations = useMemo(() => {
    return authorizations.map((auth) => ({
      ...auth,
      fallidos: Number(auth.fallidos || 0),
      cancelados: Number(auth.cancelados || 0),
    }));
  }, [authorizations]);

  // Ya no necesitamos paginación client-side, viene del servidor
  const displayAuthorizations = memoizedAuthorizations;

  // Definir el alto de cada item según el diseño de AuthorizationCard
  const ITEM_HEIGHT = 370; // Ajusta este valor según la altura real de tu AuthorizationCard + espacio deseado

  return (
    <div className="authorizations-container">
      <Filters
        filter={filter}
        onFilterChange={handleFilterChange}
        filterStatus={filterStatus}
        onFilterStatusChange={handleStatusChange}
        filterAdditionalStatus={filterAdditionalStatus}
        onFilterAdditionalStatusChange={handleFilterAdditionalStatusChange}
        filterAuthType={filterAuthType}
        onFilterAuthTypeChange={handleFilterAuthTypeChange}
        filterEPS={filterEPS}
        onFilterEPSChange={handleFilterEPSChange}
        epsOptions={epsOptions}
        onOpenCreateForm={
          hasPermission("CREAR_A") ? handleOpenCreateForm : undefined
        }
        onOpenBulkUpload={
          hasPermission("CREAR_A") ? handleOpenBulkUpload : undefined
        }
        filterNoPbs={filterNoPbs}
        onFilterNoPbsChange={handleFilterNoPbsChange}
        filterDateRange={filterDateRange}
        onFilterDateRangeChange={handleFilterDateRangeChange}
        filterCustomDateRange={filterCustomDateRange}
        onFilterCustomDateRangeChange={handleFilterCustomDateRangeChange}
        setExportModalVisible={
          hasPermission("PREVISUALIZAR_A") ? setExportModalVisible : undefined
        }
        hasPermission={hasPermission}
      />

      <div className="authorizations-list">
        {loading ? (
          <div className="loading-spinner">
            <Spin size="large" />
            <div style={{ marginTop: "10px" }}>
              Cargando autorizaciones... 
              <br />
              <small style={{ color: '#666' }}>
                Página {page} de {Math.ceil(totalAuthorizations / rowsPerPage)}
              </small>
            </div>
          </div>
        ) : displayAuthorizations.length === 0 ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '40px', 
            color: '#666',
            background: '#fafafa',
            borderRadius: '8px',
            margin: '20px 0'
          }}>
            <Alert
              message="No se encontraron autorizaciones"
              description="Intenta ajustar los filtros para ver más resultados."
              type="info"
              showIcon
            />
          </div>
        ) : (
          <AutoSizer>
            {({ height, width }) => (
              <List
                className="react-window-list"
                height={height}
                itemCount={displayAuthorizations.length}
                itemSize={ITEM_HEIGHT}
                width={width}
                overscanCount={5}
              >
                {({ index, style }) => {
                  const authorization = displayAuthorizations[index];
                  return (
                    <div
                      style={{ ...style, paddingBottom: 8 }} // Añadido paddingBottom para espacio entre tarjetas
                      key={authorization.id}
                    >
                      <AuthorizationCard
                        authorization={authorization}
                        isSelected={
                          selectedAuthorizationId === authorization.id
                        }
                        onSelect={handleSelectAuthorization}
                        onEdit={
                          hasPermission("EDITAR_A")
                            ? handleOpenEditForm
                            : undefined
                        }
                        onView={
                          hasPermission("PREVISUALIZAR_A")
                            ? handleOpenViewForm
                            : undefined
                        }
                        onDelete={
                          hasPermission("ELIMINAR_A")
                            ? handleDeleteAuthorization
                            : undefined
                        }
                        onCreateNovedad={
                          hasPermission("EDITAR_A")
                            ? handleOpenCreateNovedadForm
                            : undefined
                        }
                        onHistorialNovedades={
                          hasPermission("PREVISUALIZAR_A")
                            ? handleOpenHistorialNovedades
                            : undefined
                        }
                        onHistorialAutorizacion={
                          hasPermission("PREVISUALIZAR_A")
                            ? handleOpenHistorialAutorizacion
                            : undefined
                        }
                        onVersiones={
                          hasPermission("PREVISUALIZAR_A")
                            ? handleOpenVersiones
                            : undefined
                        }
                        onObservacionesAutorizacion={
                          hasPermission("PREVISUALIZAR_A")
                            ? handleOpenObservacionesAutorizacion
                            : undefined
                        }
                        getBorderColor={getBorderColor}
                        hasPermission={hasPermission}
                      />
                    </div>
                  );
                }}
              </List>
            )}
          </AutoSizer>
        )}
      </div>

      <div className="authorizations-footer">
        <Card variant="borderless">
          <Row justify="space-between" align="middle">
            <Col>
              <Space size="middle">
                <Tag color="blue">
                  <Text strong>Total de Autorizaciones: </Text>
                  {totalAuthorizations}
                </Tag>
                <Tag color="green">
                  <Text strong>Mostrando en Pantalla: </Text>
                  {displayAuthorizations.length}
                </Tag>
              </Space>
            </Col>
            <Col>
              <Pagination
                current={page}
                pageSize={rowsPerPage}
                total={totalAuthorizations}
                onChange={handlePageChange}
                showSizeChanger
                onShowSizeChange={handlePageSizeChange}
                pageSizeOptions={["10", "25", "50", "100"]}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} de ${total} Autorizaciones`
                }
              />
            </Col>
          </Row>
        </Card>
      </div>

      {/* Modal para Crear o Editar Autorización */}
      {openCreateEditForm && (
        <Modal
          open={openCreateEditForm}
          onCancel={handleCloseCreateEditForm}
          width={1200}
          footer={null}
          title={
            <div className="modal-title">
              {currentAuthorization
                ? "Editar Autorización"
                : "Nueva Autorización"}
            </div>
          }
        >
          <div className="modal-content">
            {currentAuthorization
              ? hasPermission("EDITAR_A") && (
                  <EditAuthorizationForm
                    key={modalKey}
                    handleClose={handleCloseCreateEditForm}
                    fetchAuthorizations={fetchAuthorizations}
                    authorization={currentAuthorization}
                  />
                )
              : hasPermission("CREAR_A") && (
                  <CreateAuthorizationForm
                    key={modalKey}
                    handleClose={handleCloseCreateEditForm}
                    fetchAuthorizations={fetchAuthorizations}
                    authorization={null}
                  />
                )}
          </div>
        </Modal>
      )}

      {/* Modal para Carga Masiva */}
      {openBulkUpload && hasPermission("CREAR_A") && (
        <Modal
          open={openBulkUpload}
          onCancel={handleCloseBulkUpload}
          footer={[
            <Button key="cancel" onClick={handleCloseBulkUpload}>
              Cancelar
            </Button>,
          ]}
          title="Carga Masiva de Autorizaciones"
        >
          <BulkUpload fetchAuthorizations={fetchAuthorizations} />
        </Modal>
      )}

      {/* modal exportar autorizaciones*/}
      <Modal
        title="Exportar Autorizaciones"
        open={exportModalVisible}
        onCancel={() => {
          setExportModalVisible(false);
          setExportDateRange(null);
          setExportError(null);
          resetExportModal();
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setExportModalVisible(false);
              setExportDateRange(null);
              setExportError(null);
              resetExportModal();
            }}
          >
            Cancelar
          </Button>,

          <Button
            key="export"
            type="primary"
            loading={exportLoading}
            onClick={handleExport}
            icon={<DownloadOutlined />}
            disabled={!hasPermission("PREVISUALIZAR_A")}
          >
            Exportar
          </Button>,
        ]}
      >
        <div style={{ padding: "20px 0" }}>
          {/* Mostrar filtros actuales */}
          <div style={{ marginBottom: "20px" }}>
            <h4>Filtros actuales que se aplicarán:</h4>
            <div style={{ padding: "10px", backgroundColor: "#f6f6f6", borderRadius: "4px", marginBottom: "16px" }}>
              <Space wrap>
                {filter && <Tag color="blue">Búsqueda: {filter}</Tag>}
                {filterStatus && <Tag color="green">Estado: {filterStatus}</Tag>}
                {filterAdditionalStatus && <Tag color="purple">Estado Adicional: {filterAdditionalStatus}</Tag>}
                {filterAuthType && <Tag color="orange">Tipo: {filterAuthType}</Tag>}
                {filterEPS && <Tag color="cyan">EPS: {filterEPS}</Tag>}
                {filterNoPbs && <Tag color="red">PBS: {filterNoPbs}</Tag>}
                {filterDateRange && <Tag color="magenta">Rango: {filterDateRange}</Tag>}
                {filterCustomDateRange.length === 2 && (
                  <Tag color="volcano">
                    Fechas: {filterCustomDateRange[0].format("DD/MM/YYYY")} - {filterCustomDateRange[1].format("DD/MM/YYYY")}
                  </Tag>
                )}
                {!filter && !filterStatus && !filterAdditionalStatus && !filterAuthType && !filterEPS && !filterNoPbs && !filterDateRange && filterCustomDateRange.length === 0 && (
                  <Tag color="default">Sin filtros aplicados</Tag>
                )}
              </Space>
            </div>
          </div>

          <h4>Seleccione el tipo de fecha:</h4>
          <Radio.Group
            onChange={(e) => setExportDateType(e.target.value)}
            value={exportDateType}
          >
            <Radio value="creacion">Fecha de Creación</Radio>
            <Radio value="inicio">Fecha de Inicio</Radio>
            <Radio value="fin">Fecha Final</Radio>
            <Radio value="rango_completo">Por rango completo</Radio>
          </Radio.Group>

          <h4>Seleccione el rango de fechas para exportar:</h4>
          <p style={{ color: "rgba(0, 0, 0, 0.45)", marginBottom: "16px" }}>
            El rango máximo permitido es de 3 meses. Este rango se aplicará junto con los filtros actuales.
          </p>
          <RangePicker
            style={{ width: "100%" }}
            onChange={(dates) => {
              setExportDateRange(dates);
              setExportError(null);
            }}
            format="DD/MM/YYYY"
          />

          {exportDateType === "rango_completo" && (
            <Alert
              message="Filtro por rango completo"
              description="Se exportarán autorizaciones que comiencen después de la fecha inicial y terminen antes de la fecha final seleccionada."
              type="info"
              showIcon
              style={{ marginTop: 16 }}
            />
          )}

          {exportError && (
            <Alert
              message="Error"
              description={exportError}
              type="error"
              showIcon
              style={{ marginTop: 16 }}
            />
          )}
        </div>
      </Modal>

      {/* Dialog para Ver Detalles de Autorización */}
      {openViewForm &&
        selectedAuthorizationId &&
        hasPermission("PREVISUALIZAR_A") && (
          <ViewAuthorizationDialog
            open={openViewForm}
            authorizationId={selectedAuthorizationId}
            handleClose={viewingHistoricalVersion ? handleCloseVersionView : handleCloseViewForm}
            versionData={selectedVersionData}
            isHistoricalVersion={viewingHistoricalVersion}
          />
        )}

      {/* Formulario para Crear Novedad */}
      {openCreateNovedadForm &&
        currentAuthorization?.id &&
        hasPermission("EDITAR_A") && (
          <CreateNovedadForm
            open={openCreateNovedadForm}
            handleClose={handleCloseCreateNovedadForm}
            authorizationId={currentAuthorization.id}
            fetchNovedades={fetchAuthorizations}
          />
        )}

      {/* Dialog para Historial de Novedades */}
      {openHistorialNovedades &&
        selectedAuthorizationId &&
        hasPermission("PREVISUALIZAR_A") && (
          <HistorialNovedadesDialog
            open={openHistorialNovedades}
            handleClose={handleCloseHistorialNovedades}
            authorizationId={selectedAuthorizationId}
          />
        )}

      {/* Dialog para Historial de Autorización */}
      {openHistorialAutorizacion &&
        selectedAuthorizationId &&
        hasPermission("PREVISUALIZAR_A") && (
          <HistorialAutorizacionDialog
            open={openHistorialAutorizacion}
            onClose={handleCloseHistorialAutorizacion}
            autorizacionId={selectedAuthorizationId}
          />
        )}

      {/* Dialog para Versiones de Autorización */}
      {openVersiones &&
        selectedAuthorizationId &&
        hasPermission("PREVISUALIZAR_A") && (
          <VersionesAutorizacionDialog
            open={openVersiones}
            onClose={handleCloseVersiones}
            autorizacionId={selectedAuthorizationId}
            onViewVersion={handleViewVersion}
          />
        )}

      {/* Dialog para Observaciones de Autorizacion */}
      {openObservacionesAutorizacion &&
        selectedAuthorizationId &&
        hasPermission("PREVISUALIZAR_A") && (
          <ObservacionesAutorizacionDialog
            open={openObservacionesAutorizacion}
            onClose={handleCloseObservacionesAutorizacion}
            autorizacionId={selectedAuthorizationId}
          />
        )}
    </div>
  );
};

export default Authorizations;
